<template>
  <div class="text-view" :class="{'text-bold': bold}">{{text}}</div>
</template>

<script>
export default {
  name: "TextView",
  props: {
    text: {
      type: String
    },
    bold: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.text-view {
  white-space: pre-line;
  word-break: break-all;
}
.text-view.text-bold {
  font-weight: bold;
}
</style>